import type { IconProps } from "./types";

export function Search({
  size = 24,
  color = "currentColor",
  ...props
}: IconProps) {
  const currentColor =
    color === "currentColor"
      ? color
      : color.includes("#")
      ? color
      : `var(--${color})`;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.90039 0C12.2634 0 15.8008 3.53734 15.8008 7.90039C15.8008 9.75737 15.1575 11.4628 14.085 12.8115L19.5371 18.2637C19.8885 18.6151 19.8885 19.1856 19.5371 19.5371C19.1857 19.8886 18.6151 19.8885 18.2637 19.5371L12.8115 14.085C11.4628 15.1575 9.75737 15.8008 7.90039 15.8008C3.53734 15.8008 0 12.2634 0 7.90039C0 3.53734 3.53734 0 7.90039 0ZM7.90039 1.80078C4.53145 1.80078 1.80078 4.53145 1.80078 7.90039C1.80078 11.2693 4.53145 14 7.90039 14C11.2693 14 14 11.2693 14 7.90039C14 4.53145 11.2693 1.80078 7.90039 1.80078Z"
        fill={currentColor}
        transform="translate(2.1 2.1)"
      />
    </svg>
  );
}
